// extracted by mini-css-extract-plugin
module.exports = {"bar":"PersonalBar-PersonalBar-bar-077d6768"};